// removed by extract-text-webpack-plugin
module.exports = {"positioning":"positioning__3dTaUlID0N6b","kbSearch":"kbSearch__20a03ceWeA7_"};